<template>
  <div class="padding-10px">
    <el-card class="box-card" shadow="none" style="min-height: 500px;">
      <div slot="header" class="clearfix" style="display: flex; flex-direction: column">
        <el-row>
          <el-col :lg="4" :md="4" :span="4">
            <el-date-picker v-model="time" style="width: 97%" align="center" type="daterange" size="medium"
              :default-time="['00:00:00', '23:59:59']" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-col>
          <el-col :lg="4" :md="4" :span="4">
            <el-select placeholder="渠道" clearable size="medium" v-model="searchChannelSelect"
              @change="searchChannelSelectChange" style="width: 90%;">
              <el-option v-for="channel in searchChannels" :value="channel.channelId" :key="channel.channelId"
                :label="channel.channelName" />
            </el-select>
          </el-col>
          <el-col :lg="3" :md="3" :span="3" v-if="isBank">
            <el-select placeholder="区域" clearable size="medium" v-model="searchSubBranchSelect"
              @change="searchSubBranchSelectChange" @focus="getSubBranch" style="width: 90%;">
              <el-option v-for="subBranch in subBranchList" :value="subBranch" :key="subBranch" :label="subBranch" />
            </el-select>
          </el-col>
          <el-col :lg="3" :md="3" :span="3" v-if="isBank">
            <el-select placeholder="网点" clearable size="medium" v-model="searchUnitOutletSelect" style="width: 90%;">
              <el-option v-for="unitOutlet in unitOutletList" :value="unitOutlet.branchNo" :key="unitOutlet.dotNodeId"
                :label="unitOutlet.unitOutlet" />
            </el-select>
          </el-col>
          <el-col :lg="2" :md="2" :span="2">
            <el-select placeholder="类型" clearable size="medium" v-model="categorySelect" @change="categorySelectChange"
              style="width: 90%;">
              <el-option v-for="item in categoryOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :lg="6" :md="6" :span="6">
            <el-select placeholder="标题" clearable size="medium" v-model="extenId" @change="searchExtenIdChange"
              style="width: 90%;">
              <el-option v-for="item in dataList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :lg="2" :md="2" :span="2">
            <el-button size="medium" type="primary" @click="getDataStatistics" icon="el-icon-search">搜索</el-button>
          </el-col>
        </el-row>
        <el-row>
          <el-col :lg="12" :md="12" :span="12">
            <el-button @click="exportData" type="success" size="medium" :loading=isExport
              v-if="checkButtonPermission('statistics:manage:export')">导出</el-button>
            <el-button @click="exportDateilData" type="success" size="medium" :loading=isDetailExport
              v-if="checkButtonPermission('statistics:manage:exportDetail')">导出明细</el-button>
          </el-col>
        </el-row>

      </div>
      <div>
        <el-table :data="tableData" border style="width: 100%" min-height="600">
          <el-table-column label="序号" align="center" width="50">
            <template slot-scope="scope"><span>{{ scope.$index + (currentPage - 1) * pageSize + 1 }} </span></template>
          </el-table-column>
          <el-table-column prop="channelName" label="渠道" min-width="120" />
          <el-table-column prop="subBranch" label="区域" min-width="80" v-if="isBankCol" />
          <el-table-column prop="unitOutlet" label="网点" min-width="100" v-if="isBankCol" />
          <el-table-column prop="type" label="类型" min-width="50" />
          <el-table-column prop="title" label="标题" min-width="120" />
          <el-table-column prop="sharePercent" label="下载率" min-width="60">
            <template slot-scope="scope">
              {{ scope.row.sharePercent | numFilter }}
            </template>
          </el-table-column>
          <el-table-column prop="notShare" label="未下载人数" min-width="60" />
          <el-table-column prop="shareCount" label="下载人数" min-width="60" />
          <el-table-column prop="peopleNumber" label="网点人数" min-width="60" />
          <el-table-column prop="shareRealCount" label="有效转发数" min-width="60" />
          <el-table-column prop="shareRealPercent" label="有效转发率" min-width="60">
            <template slot-scope="scope">
              {{ scope.row.shareRealPercent | numFilter }}
            </template>
          </el-table-column>
        </el-table>
        <div style="margin: 18px 0px; float: right;">
          <el-pagination background @current-change="currentPageChange" @size-change="pageSizeChange"
            :current-page="currentPage" :page-sizes="[5, 10, 25, 50, 100]" :page-size="pageSize" :page-count="totalPage"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "activityList",
  data() {
    return {
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      totalPage: 100,
      total: 100000,
      time: [new Date(new Date().setHours(0, 0, 0, 0)), new Date(new Date().setHours(23, 59, 59, 59))],
      searchChannels: [],
      searchChannelSelect: '',
      searchChannelSelectVal: '',
      searchStatusSelectVal: -1,
      categorySelect: '',
      dataList: [],
      extenId: '',
      isExport: false,
      isDetailExport: false,
      categoryOptions: [{ label: '文章', value: 0 },
      { label: '海报', value: 1 },
      { label: '活动', value: 2 },
      ],
      channelName: '',
      extenTitle: '',
      categoryName: '',
      searchSubBranchSelect: '',
      subBranchList: [],
      unitOutletList: [],
      searchUnitOutletSelect: '',
      isBank: true,
      isBankCol: true
    }
  },
  created() {
    let that = this
    this.getChannel()
    this.getPosters(function (r) {
      that.searchChannelSelect = 'de8941fd3cd148178f8068233e37aee1'
      that.channelName = '中国建设银行佛山市分行'
      that.categorySelect = 1
      that.categoryName = '海报'
      that.extenTitle = r.label
      that.extenId = r.value
      that.getDataStatistics();
    })
  },
  filters: {
    numFilter(value) {
      let realVal = ''
      if (!isNaN(value) && value !== '') {
        // 截取当前数据到小数点后两位
        value = value * 100
        realVal = parseFloat(value).toFixed(2)
      } else {
        realVal = '--'
      }
      return realVal + "%"
    }
  },
  methods: {
    exportDateilData() {
      this.isDetailExport = true
      let reqParam = {
        size: this.pageSize,
        currentPage: this.currentPage,
        channelId: this.searchChannelSelect,
        startTime: this.time === null ? "2020-01-01 00:00:00" : this.formatDate(this.time[0], "yyyy-MM-dd hh:mm:ss"),
        endTime: this.time === null ? "2030-01-01 00:00:00" : this.formatDate(this.time[1], "yyyy-MM-dd hh:mm:ss"),
        category: this.categorySelect,
        extenId: this.extenId,
        subBranch: this.searchSubBranchSelect === "全部" ? "" : this.searchSubBranchSelect,
        branchNo: this.searchUnitOutletSelect === "全部" ? "" : this.searchUnitOutletSelect
      };

      this.$http({
        url: '/api/front/activitydown/people/export',
        method: 'post',
        responseType: 'blob',
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        },
        data: reqParam,
      }).then(res => {
        let blob = new Blob([res.data], { type: res.headers['content-type'] });
        let downloadElement = document.createElement('a');
        let href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = '下载明细数据统计.xls'; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
        this.isDetailExport = false
      }).catch(e => {

      })
    },
    exportData() {
      this.isExport = true
      let reqParam = {
        size: this.pageSize,
        currentPage: this.currentPage,
        channelId: this.searchChannelSelect,
        startTime: this.time === null ? "2020-01-01 00:00:00" : this.formatDate(this.time[0], "yyyy-MM-dd hh:mm:ss"),
        endTime: this.time === null ? "2030-01-01 00:00:00" : this.formatDate(this.time[1], "yyyy-MM-dd hh:mm:ss"),
        category: this.categorySelect,
        extenId: this.extenId,
        channelName: this.channelName,
        extenTitle: this.extenTitle,
        categoryName: this.categoryName,
        subBranch: this.searchSubBranchSelect === "全部" ? "" : this.searchSubBranchSelect,
        branchNo: this.searchUnitOutletSelect === "全部" ? "" : this.searchUnitOutletSelect
      };
      this.$http({
        url: '/api/front/activitydown/logged/export',
        method: 'post',
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        },
        responseType: 'blob',
        data: reqParam,
      }).then(res => {
        let blob = new Blob([res.data], { type: res.headers['content-type'] });
        let downloadElement = document.createElement('a');
        let href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = '数据统计.xls'; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
        this.isExport = false
      }).catch(e => {

      })
    },
    categorySelectChange(val) {
      this.categorySelectVal = val;
      this.extenId = ''
      let obj = this.categoryOptions.find((item) => {
        return item.value === val;//筛选出匹配数据
      });
      if (obj != undefined && obj)
        this.categoryName = obj.label
      else
        this.categoryName = ''
      if (val === 0) {
        this.getArticles()
      } else if (val === 1) {
        this.getPosters()
      } else if (val === 2) {
        this.getActivitys()
      } else {
        this.dataList = []
      }
    },
    getDataStatistics() {
      let reqParam = {
        size: this.pageSize,
        currentPage: this.currentPage,
        channelId: this.searchChannelSelect,
        startTime: this.time === null ? "2020-01-01 00:00:00" : this.formatDate(this.time[0], "yyyy-MM-dd hh:mm:ss"),
        endTime: this.time === null ? "2030-01-01 00:00:00" : this.formatDate(this.time[1], "yyyy-MM-dd hh:mm:ss"),
        category: this.categorySelect,
        extenId: this.extenId,
        channelName: this.channelName,
        extenTitle: this.extenTitle,
        categoryName: this.categoryName,
        subBranch: this.searchSubBranchSelect === "全部" ? "" : this.searchSubBranchSelect,
        branchNo: this.searchUnitOutletSelect === "全部" ? "" : this.searchUnitOutletSelect
      };
      if ("de8941fd3cd148178f8068233e37aee1" === this.searchChannelSelect)
        this.isBankCol = true
      else
        this.isBankCol = false
      this.$http.post('/api/front/activitydown/logged/search', reqParam, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        let data = resp.data;
        if ("success" == data.code) {
          let pageInfo = data.pageInfo;
          this.tableData = pageInfo.list;
          // this.pageSize = pageInfo.pageSize;
          this.total = pageInfo.total;
          this.totalPage = pageInfo.pages;
        } else {
          this.$alert('' + data.message, '温馨提示', {
            confirmButtonText: '确定'
          });
        }
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      })
    },
    currentPageChange(val) {
      this.currentPage = val;
      this.getDataStatistics();
    },
    pageSizeChange(val) {
      this.pageSize = val;
      this.getDataStatistics();
    },
    searchChannelSelectChange(val) {
      this.searchChannelSelectVal = val;

      if ("de8941fd3cd148178f8068233e37aee1" === val)
        this.isBank = true
      else
        this.isBank = false

      let obj = this.searchChannels.find((item) => {
        return item.channelId === val;//筛选出匹配数据
      });
      if (obj != undefined && obj)
        this.channelName = obj.channelName
      else
        this.channelName = ''


    },
    searchExtenIdChange(val) {
      let obj = this.dataList.find((item) => {
        return item.value === val;//筛选出匹配数据
      });
      if (obj != undefined && obj)
        this.extenTitle = obj.label
      else
        this.extenTitle = ''

    },
    formatDate(time, fmt) {
      let o = {
        "M+": time.getMonth() + 1, //月份
        "d+": time.getDate(), //日
        "h+": time.getHours(), //小时
        "m+": time.getMinutes(), //分
        "s+": time.getSeconds(), //秒
        "q+": Math.floor((time.getMonth() + 3) / 3), //季度
        "S": time.getMilliseconds() //毫秒
      };
      if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (time.getFullYear() + "").substr(4 - RegExp.$1.length));
      for (let k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
      return fmt;
    },
    getChannel() {
      this.$http.post('/api/channel-service/channel/logged/all', {}, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        let data = resp.data;
        if (data.code === "success") {
          let channels = new Array();
          let allChannel = {
            label: '全部',
            value: ''
          };
          channels.push(allChannel);
          data.resultList.forEach(list => {
            channels.push(list);
          });
          let arr = data.resultList
          arr.splice(0, 1, ...arr.splice(arr.length - 1, 1, arr[0]))
          this.searchChannels = arr;
        }
      }).catch(e => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + e, '错误提示', {
          confirmButtonText: '确定'
        });
      })
    },
    getPosters(callback) {
      this.$http.post('/api/popularize/poster/search', { size: 1000, }).then(resp => {
        let data = resp.data;
        if ("success" === data.code) {
          let pageInfo = data.pageInfo;
          let datas = pageInfo.list;
          this.dataList = []
          for (let i = 0; i < datas.length; i++) {
            if (datas[i].status == 1) {
              this.dataList.push({ value: datas[i].posterId, label: datas[i].title })
            }
          }
          if (this.dataList.length > 0) {
            typeof callback == "function" && callback(this.dataList[0])
          }
        } else {
          this.$alert('' + data.message, '温馨提示', {
            confirmButtonText: '确定'
          });
        }
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      })
    },
    getArticles(callback) {
      this.$http.post('/api/popularize/article/search', { size: 1000 }).then(resp => {
        let data = resp.data;
        if ("success" === data.code) {
          let pageInfo = data.pageInfo;
          let datas = pageInfo.list;
          this.dataList = []
          for (let i = 0; i < datas.length; i++) {
            if (datas[i].status == 1) {
              this.dataList.push({ value: datas[i].articleId, label: datas[i].title })
            }
            // if(i==0){
            //   typeof callback == "function" && callback(datas[i])
            // }
          }
        } else {
          this.$alert('' + data.message, '温馨提示', {
            confirmButtonText: '确定'
          });
        }
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      })
    },
    getActivitys(callback) {
      this.$http.post('/api/front/activity/search', { currentPage: 1, size: 1000 }).then(resp => {
        let data = resp.data;
        if ("success" === data.code) {
          let pageInfo = data.pageInfo;
          let datas = pageInfo.list;
          this.dataList = []
          for (let i = 0; i < datas.length; i++) {

            if (datas[i].status == 1) {
              this.dataList.push({ value: datas[i].activityId, label: datas[i].activityName })
            }
            // if(i==0){
            //   typeof callback == "function" && callback(datas[i])
            // }
          }
        } else {
          this.$alert('' + data.message, '温馨提示', {
            confirmButtonText: '确定'
          });
        }
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      })
    },
    getSubBranch() {
      this.$http.get('/api/user-service/dotnode/getSubBranch', {}).then(resp => {
        let data = resp.data;
        this.subBranchList = ["全部"]
        if (0 === data.code || '0' === data.code) {
          this.subBranchList = this.subBranchList.concat(data.data)
        } else {
          this.$alert('' + data.message, '温馨提示', {
            confirmButtonText: '确定'
          });
        }
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      })
    },
    searchSubBranchSelectChange(val) {
      this.unitOutletList = []
      this.searchUnitOutletSelect = '全部'
      if (val === "全部") {
        this.unitOutletList = [{ branchNo: "全部", createTime: "", dotNodeId: "", subBranch: "全部", unitOutlet: "全部" }]
        return
      }
      this.$http.get('/api/user-service/dotnode/getUnitOutlet?subBranch=' + val, {}).then(resp => {
        let data = resp.data;
        if (0 === data.code || '0' === data.code) {
          this.unitOutletList = [{ branchNo: "全部", createTime: "", dotNodeId: "", subBranch: "全部", unitOutlet: "全部" }]
          this.unitOutletList = this.unitOutletList.concat(data.data)
        } else {
          this.$alert('' + data.message, '温馨提示', {
            confirmButtonText: '确定'
          });
        }
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      })
    },
    checkButtonPermission(perms) {
      let menuPermsList = sessionStorage.getItem("menuPermsList");
      if (menuPermsList.indexOf(perms) != -1) {
        return true
      } else {
        return false;
      }
    }
  }
}
</script>

<style>
.el-row:first-child {
  margin-bottom: 20px;
}

.el-row .el-button {
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/front/statisticsList.vue